import axios from 'axios';
import { buildApiUrl } from '../../../config/api';
import authService from '../../authService';
import { crudOperations } from '../../api';
import { ERROR_MESSAGES, HTTP_STATUS } from '../config/qbConstants';
import { createConnectionData, handleConnectionError } from '../utils/qbHelpers';

// Save QuickBooks connection info to MySQL API for a franchisee
export const saveConnectionInfo = async (franchiseeId, tokenInfo) => {
  try {
    const token = authService.getToken();
    if (!token) {
      throw new Error(ERROR_MESSAGES.AUTH_REQUIRED);
    }

    const response = await axios.post(
      buildApiUrl(`quickbooks/connection/${franchiseeId}`),
      createConnectionData(tokenInfo),
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    
    console.log('QuickBooks connection saved successfully');
    return response.data;
  } catch (error) {
    console.error('Error saving connection info:', error);
    throw error;
  }
};

// Get QuickBooks connection info for a franchisee (token refresh handled by backend)
export const getConnectionInfo = async (franchiseeId) => {
  try {
    const token = authService.getToken();
    if (!token) {
      throw new Error(ERROR_MESSAGES.AUTH_REQUIRED);
    }

    const response = await axios.get(
      buildApiUrl(`quickbooks/connection/${franchiseeId}`),
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    
    return response.data.connection;
  } catch (error) {
    if (error.response?.status === HTTP_STATUS.NOT_FOUND) {
      return null; // No connection found
    }
    console.error('Error getting connection info:', error);
    throw error;
  }
};

// Check if a franchisee has a QuickBooks connection via MySQL API
export const hasConnection = async (franchiseeId) => {
  try {
    console.log('Checking connection for franchiseeId:', franchiseeId);
    
    const response = await crudOperations.get(`/quickbooks/connection/${franchiseeId}`);

    console.log('Backend connection status response:', response.data);
    const connected = response.data.connected === true;
    
    return connected;
  } catch (error) {
    return handleConnectionError(error, franchiseeId);
  }
};

// Disconnect QuickBooks for a franchisee via MySQL API
export const disconnect = async (franchiseeId) => {
  try {
    const token = authService.getToken();
    if (!token) {
      throw new Error(ERROR_MESSAGES.AUTH_REQUIRED);
    }

    await axios.delete(
      buildApiUrl(`quickbooks/connection/${franchiseeId}`),
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    return true;
  } catch (error) {
    console.error('Error disconnecting QuickBooks:', error);
    throw error;
  }
};